import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AppLayout from '../components/AppLayout';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const MemberTrackerBoard = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [board, setBoard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMemberTrackerBoard();
  }, []);

  const fetchMemberTrackerBoard = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/boards`, { credentials: 'include' });
      if (response.ok) {
        const boards = await response.json();
        const memberBoard = boards.find(b => b.board_type === 'member_tracking');
        if (memberBoard) {
          // Preserve card query param if present
          const cardId = searchParams.get('card');
          const queryString = cardId ? `?card=${cardId}` : '';
          navigate(`/board/${memberBoard.board_id}${queryString}`);
        } else {
          setBoard(null);
        }
      }
    } catch (error) {
      console.error('Failed to fetch board:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AppLayout title="Member Tracker">
        <div className="text-[#A2FF00]">Loading...</div>
      </AppLayout>
    );
  }

  return (
    <AppLayout title="Member Tracker">
      <div className="text-gray-400">No member tracker board found. Please contact an administrator.</div>
    </AppLayout>
  );
};

export default MemberTrackerBoard;
